import ErrorMessage from './ErrorMessage';
import OfferList from './OfferList';
import ShowAllOffersLink from './ShowAllOffersLink';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import HomepageSectionTitle from './HomepageSectionTitle';
import HomepageSectionContainer from './HomepageSectionContainer';
import OfferAvailableSoon from './OfferAvailableSoon';
import { useAvailableSoonOffers } from '../hooks/useAvailableSoonOffers';
import ChevronCta from './ChevronCTA';
import '../scss/offer.scss';

const AvailableSoonOffersList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = searchParams.get(SEARCH_PARAMS.LOCATION) || undefined;

  const { error, data: offers } = useAvailableSoonOffers(location);

  const handleSeeAllOffers = () => {
    navigate('/ponude?coming_soon=1');
  };

  return (
    <>
      {error && <ErrorMessage>{error.message}</ErrorMessage>}

      {offers?.length && (
        <HomepageSectionContainer className="available-soon-section pt-4">
          <HomepageSectionTitle cta={<ChevronCta handleClick={handleSeeAllOffers} label="Pogledaj sve" />}>
            Uskoro dostupno
          </HomepageSectionTitle>
          <OfferList className="row-of-offers mb-4">
            {offers &&
              Boolean(offers.length) &&
              offers.map(offer => <OfferAvailableSoon key={offer.id} offer={offer} />)}
            <ShowAllOffersLink displayedIn="Uskoro dostupno" />
          </OfferList>
        </HomepageSectionContainer>
      )}
    </>
  );
};

export default AvailableSoonOffersList;
